import React from 'react';
import { useFormContext } from 'react-hook-form';

import { ScreenMajorTurnOff as ScreenMajorTurnOffFemale } from '../../../OwnAI/screens/MajorTurnOff';
import { ScreenMajorTurnOff as ScreenMajorTurnOffMale } from '../../../OwnAIMan/screens/MajorTurnOff';
import { LayoutDataType } from '../../types';

export const ScreenMajorTurnOff: React.FC = () => {
  const form = useFormContext<LayoutDataType>();
  const gender = form.watch('gender');

  if (gender === 'male') {
    return <ScreenMajorTurnOffMale />;
  }

  return <ScreenMajorTurnOffFemale />;
};
